module.exports = __webpack_public_path__ + "static/4-80f3bce6b6f52f4e91324a678e12edd9.png";